import React, { useState, useEffect } from 'react';
import FacilityCard from './FacilityCard.jsx';
import FacilityModal from './FacilityModal.jsx';

import axios from 'axios';
import { auth } from '../../config/firebase';
import { API_BASE } from '../../config/apiBase';

const API = `${API_BASE}/manager/website`;

export default function FacilitiesTab({ facilities, setFacilities }) {
  const [expandedFacility, setExpandedFacility] = useState(null);
  const [facilityModal, setFacilityModal] = useState({ open: false, editIndex: null, data: null });

  // Assign the lowest available facility_id (no gaps, unique per hotel)
  // Fetch latest facilities from backend
  const fetchFacilities = async () => {
    try {
      let token = null;
      if (auth.currentUser) {
        token = await auth.currentUser.getIdToken();
      }
      const res = await axios.get(`${API}/facilities`, {
        headers: token ? { Authorization: `Bearer ${token}` } : {}
      });
      setFacilities(res.data.data);
      console.log('[FacilityTab] Synced facilities from backend:', res.data.data.map(f => f.facility_id));
    } catch (err) {
      console.error('[FacilityTab] Failed to fetch facilities:', err);
    }
  };

  useEffect(() => {
    fetchFacilities();
    // eslint-disable-next-line
  }, []);

  const handleAddEditFacility = async (data, editIndex) => {
    let token = null;
    if (auth.currentUser) {
      token = await auth.currentUser.getIdToken();
    }
    // Ensure price/charge_type consistency
    let payload = { ...data };
    if (Number(payload.price) === 0) {
      payload.charge_type = 'Free';
    }
    if (editIndex != null && facilities[editIndex]) {
      // Update facility in backend (use primary key id for endpoint)
      try {
        await axios.put(`${API}/facilities/${facilities[editIndex].id}`, payload, {
          headers: token ? { Authorization: `Bearer ${token}` } : {}
        });
        console.log('[FacilityTab] Edited facility:', payload, 'at index:', editIndex);
        await fetchFacilities();
      } catch (err) {
        console.error('[FacilityTab] Failed to edit facility:', err);
      }
    } else {
      // Find all used facility_ids
      const usedIds = facilities.map(f => f.facility_id).filter(id => typeof id === 'number');
      let newId = 1;
      while (usedIds.includes(newId)) {
        newId++;
      }
      for (let i = 1; i < newId; i++) {
        if (!usedIds.includes(i)) {
          newId = i;
          break;
        }
      }
      const newFacility = { ...payload, facility_id: newId };
      // Add facility to backend (assume POST endpoint exists)
      try {
        await axios.post(`${API}/facilities`, newFacility, {
          headers: token ? { Authorization: `Bearer ${token}` } : {}
        });
        console.log('[FacilityTab] Added facility:', newFacility);
        await fetchFacilities();
      } catch (err) {
        console.error('[FacilityTab] Failed to add facility:', err);
      }
    }
  };

  const handleDeleteFacility = async id => {
    // Delete facility from backend (assume DELETE endpoint exists)
    let token = null;
    if (auth.currentUser) {
      token = await auth.currentUser.getIdToken();
    }
    try {
      await axios.delete(`${API}/facilities/${id}`, {
        headers: token ? { Authorization: `Bearer ${token}` } : {}
      });
      console.log('[FacilityTab] Deleted facility with id:', id);
      await fetchFacilities();
    } catch (err) {
      console.error('[FacilityTab] Failed to delete facility:', err);
    }
  };
  return (
    <div className="card facilities-tab">
      <div style={{ marginBottom: 12, color: '#555' }}>
        Add only facilities that are shared across the entire hotel.
      </div>
      <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 12 }}>
        <button className="add-facility-btn" onClick={() => setFacilityModal({ open: true, editIndex: null, data: null })}>
          + Add Facility
        </button>
      </div>

      <div className="facility-list">
        {facilities.map((f, idx) => (
          <FacilityCard
            key={f.id || idx}
            facility={f}
            expanded={expandedFacility === idx}
            onExpand={() => setExpandedFacility(expandedFacility === idx ? null : idx)}
            onEdit={() => setFacilityModal({ open: true, editIndex: idx, data: f })}
            onDelete={() => handleDeleteFacility(f.id)}
          />
        ))}
        {facilities.length === 0 && <div style={{ textAlign: 'center', margin: '32px 0', color: '#888' }}>No facilities added yet.</div>}
      </div>

      {facilityModal.open && (
        <FacilityModal
          initial={facilityModal.data}
          onClose={() => setFacilityModal({ open: false, editIndex: null, data: null })}
          onSave={(data) => handleAddEditFacility(data, facilityModal.editIndex)}
        />
      )}
    </div>
  );
}
